import infoContent from '../text-content/info-content';


var glossary = new Array;
for(var o in infoContent.glossary) {
    glossary.push( infoContent.glossary[o]);
}

glossary.sort((a,b)=>{
    var nameA = a.title.toUpperCase(); // ignore upper and lowercase
    var nameB = b.title.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
        return -1;
    }
    if (nameA > nameB) {
        return 1;
    }

    // names must be equal
    return 0;
})

//----Open the glossary module
var modalGlossary = 
`
<div class="modal-glossary_close initial-hidden">X</div>
<div class="modal-glossary initial-hidden">
`;


    //----Open the glossary definitions container
    modalGlossary += 
    `
    <div class="glossary-def-container">
    `;

    for(var i = 0; i< glossary.length; i++){
        if (i%2 === 0){
            modalGlossary += `<div class="glossary-page initial-hidden">`
        }
        var word = glossary[i];
        modalGlossary +=
        `<div class="glossary-definition">
            <p class="title">${word.title}</p>
            <p class="description">${word.description}</p>
        </div>
        `;
        if (i%2 !== 0 || i+1 === glossary.length){
            modalGlossary += `</div>`
        }
    }

    //----close the glossary definitions container
    modalGlossary += 
    `
    </div">
    `;

//----Close the glossary module
modalGlossary +=
`
</div>
<div class="glossary-nav">
    <div class="glossary-btn-container">
        <button class="glossary-nav--back initial-hidden"> </button>
    </div>
    <div class="glossary-btn-container">
        <button class="glossary-nav--next"> </button>
    </div>
</div">
`;

export default modalGlossary;


// WEBPACK FOOTER //
// ./src/js/html-modules/modal-glossary-html.js